import { IS_ACTIVE, IS_VISIBLE } from './constants';

function toggleForumReplies(): void {
    const forumThreads: NodeListOf<HTMLDivElement> = document.querySelectorAll('.js-forum__thread');

    if (forumThreads.length) {
        forumThreads.forEach((forumThread: HTMLDivElement) => {
            const forumRepliesToggle: HTMLAnchorElement | null = forumThread.querySelector('.js-toggle-replies');
            const toggleClose: string | null | undefined = forumRepliesToggle?.getAttribute('data-close');
            const toggleOpen: string | null | undefined = forumRepliesToggle?.getAttribute('data-open');

            forumRepliesToggle?.addEventListener('click', (e: Event) => {
                e.preventDefault();

                const forumReplies: HTMLDivElement | null = forumThread.querySelector('.forum__replies');

                forumThread.classList.toggle(IS_ACTIVE);
                forumReplies?.classList.toggle(IS_VISIBLE);

                if (toggleOpen && toggleClose) {
                    forumRepliesToggle.innerHTML = forumThread.classList.contains(IS_ACTIVE) ? toggleClose : toggleOpen;
                }
            });
        });
    }
}

toggleForumReplies();
